import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { autorun, reaction } from 'mobx';
import cx from 'classnames';
import {
  Dimmer, Segment, Loader, Label, Icon, Modal, Pagination, Input, Header
} from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { withTranslation } from 'react-i18next';
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import api from '../../api';
import MultiSeriesPieChart from '../Extensions/MultiSeriesPieChart';
import PieChart from '../Extensions/PieChart';
import MatchedModal from '../Modal/MatchedModal';
import Footer from '../Footer/Footer';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import jsBundled from '../../images/icons/parcel.png';
import EditScanResultModal from '../Modal/EditScanResultModal';
import DependencyModal from '../Modal/DependencyModal';
import WithRouter from '../Extensions/WithRouter';
import ScannedFileRow from './ScannedFileRow';
import FeedModal from '../Modal/FeedModal';

class OverviewfileDetail extends Component {
  constructor(props) {
    super(props);
    const { params, state } = this.props;
    this.modalAction = null;
    this.modalBody = null;
    this.smallBody = null;
    this.operation = 'click';
    this.viewRef = React.createRef();
    this.overviewDetail = React.createRef();
    this.state = {
      isOpenMER: false,
      isLoaderMER: false,
      isOpenMDP: false,
      isOpenWarnModal: false,
      idReport: params.idReport,
      selectedScannedFileId: '',
      selectedScannedFileName: '',
      selectedComponentList: [],
      hasLanguage: '',
      pageSize: state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      hasMore: false,
      scannedFileList: [],
      activeIndex: [],
      isOpenMIF: false,
      sortValue: '3',
      isSort: false,
      searchKeyword: '',
      filter: [],
      matchedList: '',
      popupIndex: [],
      popupType: '',
      componentList: [],
      sumData: {},
      customChecksum: null,
      customSize: null,
      viewMode: state.user.view_mode,
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      updateScanResultObject: {
        isUpdate: false,
        fileId: '',
      },
      isOpenMFD: false,
      currentScannedFileId: '',
      currentScannedFileName: '',
      commentList: [],
    };
  }

  componentDidMount() {
    const { state } = this.props;
    window.addEventListener('scroll', this.handleOnScroll);
    document.addEventListener('mousedown', this.handleClickOutside);

    this.bindScrollEffect();
    this.bindMouseOverTitles();
    window.scrollTo(0, 0);

    this.disposeUserReaction = autorun(() => {
      this.setState({
        viewMode: state.user.view_mode,
        pageSize: state.user.page_limit,
      });
    });

    this.disposeCustomChecksumReaction = reaction(
      () => { return state.report.customChecksum; },
      (customChecksum) => {
        if (customChecksum !== null) {
          const { customSize } = state.report;
          this.updateDefinedFilter(customChecksum, customSize);
        }
      },
      {
        fireImmediately: true,
      }
    );

    this.disposeScannedFileListReaction = reaction(
      () => { return state.user.currentPrecisionLevel; },
      (currentPrecisionLevel) => {
        if (currentPrecisionLevel !== null && this.overviewDetail) {
          this.getScannedFileList();
        }
      },
      {
        fireImmediately: true
      }
    );
  }

  componentDidUpdate(prevProps) {
    const { params } = this.props;
    if (prevProps.params.idReport !== params.idReport) {
      this.resetStateForNewReport(params.idReport);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);
    $(window).off('scroll.contents_header', this.handleScroll);
    $(document).off('mouseover', this.handleMouseOver);
    if (this.disposeUserReaction) {
      this.disposeUserReaction();
    }

    if (this.chart) {
      this.chart.destroy();
    }

    if (this.disposeUserReaction) {
      this.disposeUserReaction();
    }
    if (this.disposeCustomChecksumReaction) {
      this.disposeCustomChecksumReaction();
    }
    if (this.disposeScannedFileListReaction) {
      this.disposeScannedFileListReaction();
    }
  }

  handleActivePageChange = (e) => {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        scannedFileList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getScannedFileList(activePage, pageSize);
      });
    }
  };

  handleInputActivePageChange = (e, { value }) => {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  };

  handlePageSizeChange = (value) => {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        scannedFileList: [],
        activeIndex: [],
      },
      () => {
        this.getScannedFileList();
      }
    );
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      scannedFileList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getScannedFileList(activePage, pageSize);
    });
  };

  handleClose = () => {
    this.setState({
      isOpenMIF: false,
    });
  };

  handleOnScroll = () => {
    const {
      getScannedFileList,
      state: {
        error, isLoading, hasMore, viewMode, currentPage
      },
    } = this;
    if (viewMode === 'list') {
      return;
    }
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getScannedFileList(currentPage + 1);
    }
  };

  handleChange = (value) => {
    this.setState(
      {
        searchKeyword: value,
        scannedFileList: [],
        activeIndex: [],
      },
      () => {
        this.getScannedFileList();
      }
    );
  };

  handleFilterData = (value) => {
    this.setState(
      {
        scannedFileList: [],
        activeIndex: [],
        filter: value.filter,
      },
      () => {
        this.getScannedFileList();
      }
    );
  };

  handleMoreInfo = (index) => {
    const { popupIndex } = this.state;
    let newState;

    if (popupIndex.indexOf(index) === -1) {
      newState = [...popupIndex, index];
    } else {
      newState = popupIndex;
    }

    this.setState({
      popupIndex: newState,
      popupType: 'type_0',
    });
  };

  handleMDPOpen = (id) => {
    const { scannedFileList } = this.state;

    const selectedIndex = scannedFileList.findIndex((item) => {
      return item.scannedFileId === id;
    });

    this.setState({
      isOpenMDP: true,
      selectedScannedFileName: scannedFileList[selectedIndex].name,
      selectedScannedFileId: id,
      selectedComponentList: scannedFileList[selectedIndex].componentList.components,
      hasLanguage: scannedFileList[selectedIndex].componentList.language,
    });
  };

  handleMERClose = () => {
    this.setState({
      isOpenMER: false,
      componentList: [],
      sumData: {},
    });
  };

  handlePopupClose = (index) => {
    const { popupIndex } = this.state;
    const newState = popupIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      popupIndex: newState,
      popupType: '',
    });
  };

  handleMDPClose = () => {
    this.setState({
      isOpenMDP: false,
    });
  };

  handleClickOutside = (event) => {
    const { popupIndex, popupType } = this.state;
    const container = $('.card_detail_popup .popup_box');
    if (container && container.has(event.target).length === 0) {
      if (popupIndex.length !== 0 && popupType !== '') {
        this.setState({
          popupIndex: '',
          popupType: '',
        });
        return true;
      }
      return false;
    }
  };

  handleModalLoader = (value) => {
    this.setState({
      isLoaderMER: value,
    });
  };

  handleSearchChange = (value) => {
    this.setState({
      searchKeyword: value,
    });
  };

  handleMFDOpen = (id, name, list) => {
    this.setState({
      isOpenMFD: true,
      currentScannedFileId: id,
      currentScannedFileName: name,
      commentList: list,
    });
  };

  getScannedFileEditDetails = (ufid, sfid, cid) => {
    const { state } = this.props;
    let type;
    if (state.user.currentPrecisionLevel) {
      type = state.user.currentPrecisionLevel;
    } else {
      type = null;
    }
    this.setState({
      isLoaderMER: true,
      isOpenMER: true,
    }, () => {
      api.getScannedFileEditDetails(ufid, sfid, type)
        .then((response) => {
          const data = response.response;
          const customIds = [];

          while (customIds.length < data.components.length) {
            const r = uuidv4();
            customIds.push(r);
          }

          const componentList = data.components.map((row, index) => {
            return {
              id: customIds[index],
              component_name: row.component_name,
              component_version: row.component_version,
              securities: row.securities,
              title_license: row.title_license,
              homepage: row.homepage,
            };
          });
          const sumData = {
            checksum: data.checksum,
            scanned_file_id: data.scanned_file_id,
            uploaded_file_id: data.uploaded_file_id,
            component_ids: cid,
            project_id: data.project_id,
            project_version_id: data.project_version_id,
            project_name: data.project_name,
            project_version_name: data.project_version_name,
            name: data.name,
            has_global_permission: data.has_global_permission,
            is_applied: data.is_applied,
            coverage: data.coverage || '',
            comment: data.comment || '',
          };

          this.setState({
            isLoaderMER: false,
            componentList,
            sumData,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  onChangeSorting = (e) => {
    const { sortValue, isSort } = this.state;
    if (e.currentTarget.dataset.id !== sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          scannedFileList: [],
          activeIndex: [],
        },
        () => {
          this.getScannedFileList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          scannedFileList: [],
          activeIndex: [],
        },
        () => {
          this.getScannedFileList();
        }
      );
    }
  };

  setPrecisionLevel = (value) => {
    const { state } = this.props;
    this.setState({
      scannedFileList: [],
      activeIndex: [],
    }, () => {
      state.user.setPrecisionLevel(value);
    });
  };

  updateScannedFileList = (uploadedFileId, scannedFileId) => {
    const {
      pageSize,
      filter,
      customChecksum,
      searchKeyword,
      customSize,
      idReport,
      scannedFileList,
      updateScanResultObject,
      sortValue,
      isSort,
    } = this.state;
    const { state, t, navigate } = this.props;

    const updateIndexInFullList = scannedFileList.findIndex(
      (item) => { return item.scannedFileId === scannedFileId; }
    );

    let pageToUpdate = 1;
    if (updateIndexInFullList !== -1 && pageSize > 0) {
      pageToUpdate = Math.floor(updateIndexInFullList / pageSize) + 1;
    }

    const page = pageToUpdate;
    const perPage = pageSize;
    const precisionLevel = state.user.currentPrecisionLevel || null;
    const filterData = filter.length ? filter.join(',') : '';

    const sortOrderMappings = {
      1: isSort ? 'scanned_file' : 'scanned_file_r',
      2: isSort ? 'component_count_r' : 'component_count',
      3: isSort ? 'component_match_type_r' : 'component_match_type',
      4: isSort ? 'component_name' : 'component_name_r',
      5: isSort ? 'component_version_r' : 'component_version',
      6: isSort ? 'security_count_r' : 'security_count',
      7: isSort ? 'license_count_r' : 'license_count',
      8: isSort ? 'title_license' : 'title_license_r',
      9: isSort ? 'litigator_count_r' : 'litigator_count',
      10: isSort ? 'component_score_r' : 'component_score',
    };
    const orderText = sortOrderMappings[sortValue] || 'component_score';

    const data = {
      search: searchKeyword,
      filter: filterData,
      page,
      limit: perPage,
      order: orderText,
      precision_level: precisionLevel,
    };

    if (customChecksum) {
      data.custom_apply = {
        checksum: customChecksum,
        size: customSize,
      };
    }

    api.getScannedFileList(data, idReport)
      .then((response) => {
        const nextScannedFileList = response.response.map((item) => {
          return {
            scannedFileId: item.scanned_file_id,
            uploadedFileId: item.uploaded_file_id,
            componentIds: item.component_ids,
            pid: item.project_id,
            pvid: item.project_version_id,
            name: item.name,
            componentCount: item.component_count,
            componentScore: item.component_score,
            componentName: item.component_name,
            componentVersion: item.component_version,
            securityCount: item.security_count,
            licenseCount: item.license_count,
            titleLicense: item.title_license,
            litigatorString: item.litigator_string,
            securities: item.securities,
            licenses: item.licenses,
            litigators: item.litigators,
            matchType: item.match_type,
            hasExploit: item.has_exploit,
            isBundled: item.is_bundled,
            componentMatchType: item.component_match_type,
          };
        });

        const updateIndex = scannedFileList.findIndex((item) => { return item.scannedFileId === scannedFileId; });
        if (scannedFileList.length === 0) {
          return navigate('/results/overview');
        }

        if (updateIndex !== -1) {
          const updatedItem = nextScannedFileList.find((item) => { return item.scannedFileId === scannedFileId; });
          if (updatedItem) {
            const updatedScannedFileList = [...scannedFileList];
            updatedScannedFileList[updateIndex] = {
              ...updatedScannedFileList[updateIndex],
              ...updatedItem
            };
            this.setState({ scannedFileList: updatedScannedFileList }, () => {
              this.setState((prevState) => {
                return {
                  activeIndex: [...prevState.activeIndex, updateIndex],
                };
              });
              this.getScannedDetail(idReport, updateScanResultObject.fileId, updatedItem.componentIds);
              state.user.setUpdateSummaryValue(true);
            });
          } else {
            this.setState({ activeIndex: [] });
            state.user.setUpdateSummaryValue(true);
          }
        }

      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  getScannedFileList = (pageNo, limit) => {
    const {
      pageSize,
      filter,
      customChecksum,
      searchKeyword,
      customSize,
      idReport,
      scannedFileList,
      sortValue,
      isSort,
    } = this.state;
    const { state, t } = this.props;

    const page = pageNo || 1;
    const perPage = limit || pageSize || state.user.page_limit || localStorage.getItem('page_limit');
    const precisionLevel = state.user.currentPrecisionLevel || null;
    const filterData = filter.length ? filter.join(',') : '';

    const sortOrderMappings = {
      1: isSort ? 'scanned_file' : 'scanned_file_r',
      2: isSort ? 'component_count_r' : 'component_count',
      3: isSort ? 'component_match_type_r' : 'component_match_type',
      4: isSort ? 'component_name' : 'component_name_r',
      5: isSort ? 'component_version_r' : 'component_version',
      6: isSort ? 'security_count_r' : 'security_count',
      7: isSort ? 'license_count_r' : 'license_count',
      8: isSort ? 'title_license' : 'title_license_r',
      9: isSort ? 'litigator_count_r' : 'litigator_count',
      10: isSort ? 'component_score_r' : 'component_score',
    };
    const orderText = sortOrderMappings[sortValue] || 'component_score';

    const data = {
      search: searchKeyword,
      filter: filterData,
      page,
      limit: perPage,
      order: orderText,
      precision_level: precisionLevel,
    };

    if (customChecksum) {
      data.custom_apply = {
        checksum: customChecksum,
        size: customSize,
      };
    }

    this.setState({ isLoading: true }, () => {
      api.getScannedFileList(data, idReport)
        .then((response) => {
          if (scannedFileList.length !== 0 && response.pagination.current === 1) {
            return;
          }

          const nextScannedFileList = response.response.map((item) => {
            return {
              scannedFileId: item.scanned_file_id,
              uploadedFileId: item.uploaded_file_id,
              componentIds: item.component_ids,
              pid: item.project_id,
              pvid: item.project_version_id,
              name: item.name,
              componentCount: item.component_count,
              componentScore: item.component_score,
              componentName: item.component_name,
              componentVersion: item.component_version,
              securityCount: item.security_count,
              licenseCount: item.license_count,
              titleLicense: item.title_license,
              litigatorString: item.litigator_string,
              securities: item.securities,
              licenses: item.licenses,
              litigators: item.litigators,
              matchType: item.match_type,
              hasExploit: item.has_exploit,
              isBundled: item.is_bundled,
              componentMatchType: item.component_match_type,
            };
          });

          this.setState({
            currentPage: response.pagination.current,
            pageSize: response.pagination.per_page,
            totalPage: response.pagination.pages,
            currentCount: response.pagination.count,
            hasMore: response.pagination.next !== null,
            isLoading: false,
            scannedFileList: [...scannedFileList, ...nextScannedFileList],
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            error: t('modal.error.error_load'),
            isLoading: false,
          });
        });
    });
  };

  getScannedDetail = (uid, sfid, cids) => {
    const { state } = this.props;
    const precisionLevel = state.user.currentPrecisionLevel || null;

    this.setState({
      isDetailLoading: true,
      isVisible: sfid,
    }, () => {
      api.getScannedDetail(uid, sfid, cids, precisionLevel)
        .then((response) => {
          const data = response.response;
          const { scannedFileList, updateScanResultObject } = this.state;
          const updatedIndex = scannedFileList.findIndex((item) => { return item.scannedFileId === sfid; });

          if (updatedIndex !== -1) {
            let updatedScannedFile;

            if (updateScanResultObject.isUpdate === true) {
              const currentItem = scannedFileList[updatedIndex];

              const matchingComponentIndex = data.components.findIndex(
                (comp) => {
                  return comp.component_name === currentItem.componentName
                        && comp.component_version === currentItem.componentVersion;
                }
              );

              if (matchingComponentIndex !== -1) {
                const matchedComponent = data.components[matchingComponentIndex];

                updatedScannedFile = {
                  ...currentItem,
                  componentList: data,
                  matchType: data.match_type,
                  componentCount: data.components.length,
                  componentMatchType: matchedComponent.component_match_type,
                  componentScore: matchedComponent.component_score,
                  componentName: matchedComponent.component_name,
                  componentVersion: matchedComponent.component_version,
                  securityCount: matchedComponent.security_count,
                  licenseCount: matchedComponent.license_count,
                  titleLicense: matchedComponent.title_license,
                  litigatorString: matchedComponent.litigator_string,
                  securities: matchedComponent.securities,
                  licenses: matchedComponent.licenses,
                  litigators: matchedComponent.litigators,
                  hasExploit: matchedComponent.has_exploit,
                };
              } else {
                updatedScannedFile = {
                  ...currentItem,
                  componentList: data,
                };
                console.warn('Matching component not found in data.components for updateScanResultObject.isUpdate === true');
              }
            } else {
              updatedScannedFile = {
                ...scannedFileList[updatedIndex],
                componentList: data,
              };
            }

            const newData = [
              ...scannedFileList.slice(0, updatedIndex),
              updatedScannedFile,
              ...scannedFileList.slice(updatedIndex + 1),
            ];

            this.setState({
              scannedFileList: newData,
              isDetailLoading: false,
              isVisible: '',
              updateScanResultObject: { isUpdate: false, fileId: '' },
            });
          } else {
            this.setState({
              isDetailLoading: false,
              isVisible: '',
            });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  getMatchedList = (uid, sfid) => {
    const { state, t } = this.props;
    let type;
    if (state.user.currentPrecisionLevel) {
      type = state.user.currentPrecisionLevel;
    } else {
      type = null;
    }
    api
      .getMatchedList(uid, sfid, type)
      .then((response) => {
        if (response.status === 200) {
          const res = response.data.response;
          const rawTabs = [];
          Object.keys(res).map((obj) => {
            if (res[obj].show) {
              rawTabs.push(obj);
            }
            return false;
          });

          if (rawTabs.length !== 0) {
            this.setState({
              matchedList: res,
              isOpenMIF: true,
            });
          } else {
            this.modalAction = t('modal.title.attention');
            this.modalBody = t('modal.message.no_matched_detail');
            this.setState({
              matchedList: res,
              isOpenWarnModal: true,
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;
      //containerEl.style.display = 'none';

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandSummary = clonedObject.getElementsByClassName('contents_summary expand');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalAction = t('modal.title.attention');
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }
        //expand

        //.contents_summary .contents_summary_inner .date_info  left: 0
        // .contents_summary .expand_contents  height 144px

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (expandSummary.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('height', '275px', 'important');
          const dataInfo = clonedObject.getElementsByClassName('date_info');
          const expand_button = clonedObject.getElementsByClassName('expand_button');
          dataInfo[0].style.setProperty('left', '0', 'important');
          while (expand_button.length > 0) {
            expand_button[0].parentNode.removeChild(expand_button[0]);
          }
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }
        if (expandSummary.length > 0 && tableEl.length > 12) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 12 && tableEl.length > 13) || (i > 12 && (i - 12) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }

        //wide_card_box wide_card_type_01
        if (expandSummary.length === 0 && tableEl.length > 16) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 15 && tableEl.length > 16) || (i > 15 && (i - 15) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleRow = (index, scannedFileId, componentIds) => {
    const { activeIndex, idReport } = this.state;
    let newState;

    this.renderCheckEvent();

    if (this.operation === 'drag' || this.operation === null) {
      return;
    }

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getScannedDetail(idReport, scannedFileId, componentIds);
      newState = [...activeIndex, index];
    }
    this.setState({
      activeIndex: newState,
    });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      scannedFileList: [],
      activeIndex: [],
    }, () => {
      this.getScannedFileList();
    });
  };

  handleSaveCallback = (sumData) => {
    const { t } = this.props;
    const {
      uploaded_file_id,
      scanned_file_id,
      is_applied,
      coverage,
    } = sumData;

    this.modalAction = t('modal.title.notice');
    if (!is_applied) {
      this.modalBody = t('modal.message.save_is_not_apply_next_scan');
      this.smallBody = null;
    }

    if (is_applied && coverage) {
      if (coverage === 'project') {
        this.modalBody = t('modal.message.save_is_apply_next_scan_project');
        this.smallBody = t('modal.message.save_is_apply_next_scan_project_sub');
      }
      if (coverage === 'company') {
        this.modalBody = t('modal.message.save_is_apply_next_scan_project');
        this.smallBody = t('modal.message.save_is_apply_all_scan');
      }
    }

    this.setState({
      isOpenMER: false,
      isOpenWarnModal: true,
      componentList: [],
      sumData: {},
      updateScanResultObject: {
        isUpdate: true,
        fileId: scanned_file_id,
      }
    }, () => {
      this.updateScannedFileList(uploaded_file_id, scanned_file_id);
    });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        activeIndex: [],
        scannedFileList: [],
        filter: newState,
      },
      () => {
        this.getScannedFileList();
      }
    );
  };

  clearAllValue = () => {
    const { state } = this.props;
    this.setState(
      {
        scannedFileList: [],
        activeIndex: [],
        filter: [],
        searchKeyword: '',
      },
      () => {
        this.getScannedFileList();
        state.report.initCustomApply();
      }
    );
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  closeMFDModal = (list) => {
    const { commentList } = this.state;
    this.setState({
      isOpenMFD: false,
    });
    if (list !== 0 && (commentList.length !== list.length)) {
      this.updateCommentList(list);
    }
  };

  updateCommentList = (newComments) => {
    const { currentScannedFileId, scannedFileList } = this.state;

    const updatedList = scannedFileList.map((file) => {
      if (file.scannedFileId === currentScannedFileId) {
        return {
          ...file,
          componentList: {
            ...file.componentList,
            more_information: {
              ...file.componentList.more_information,
              comment: newComments
            }
          }
        };
      }
      return file;
    });

    this.setState({ scannedFileList: updatedList });
  };

  resetStateForNewReport = (idReport) => {
    this.setState({
      idReport,
      scannedFileList: [],
      activeIndex: [],
      filter: [],
      customChecksum: null,
      customSize: null,
      updateScanResultObject: {
        isUpdate: false,
        fileId: '',
      },
    }, this.getScannedFileList);
  };

  bindScrollEffect = () => {
    const $window = $(window);
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');

    const handleScroll = () => {
      if ($window.scrollTop() > 200) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    };

    $window.on('scroll.contents_header', handleScroll);

    this.handleScroll = handleScroll;
  };

  bindMouseOverTitles = () => {
    const handleMouseOver = (event) => {
      const $target = $(event.currentTarget);
      if (event.currentTarget.offsetWidth < event.currentTarget.scrollWidth && !$target.attr('title')) {
        $target.attr('title', $target.text());
      }
    };

    $(document).on('mouseover', '.wide_card_table .tac, .wide_card_table .tal, .card_detail_popup .popup_content .text_ellipsis, .ui.popup .expand_sub_popup .block.block_6, .wide_card_table .value_wrap .value', handleMouseOver);

    this.handleMouseOver = handleMouseOver;
  };

  clearCustomApply = () => {
    const { state } = this.props;
    this.setState({
      searchKeyword: '',
      scannedFileList: [],
      activeIndex: [],
      customChecksum: null,
      customSize: null,
    }, () => {
      state.report.initCustomApply();
      this.getScannedFileList();
    });
  };

  clearSearch = () => {
    this.setState(
      {
        searchKeyword: '',
        scannedFileList: [],
        activeIndex: [],
      },
      () => {
        this.getScannedFileList();
      }
    );
  };

  updateDefinedFilter = (checksum, size) => {
    const { state } = this.props;
    this.setState({
      customChecksum: checksum,
      customSize: size,
    }, () => {
      state.report.initCustomApply();
    });
  };

  renderValue = () => {
    const { filter, customChecksum } = this.state;
    const { t } = this.props;

    const securityFilter = filter.filter((item) => {
      return item.indexOf('security') > -1;
    });

    const licenseFilter = filter.filter((item) => {
      return item.indexOf('license') > -1;
    });

    const litigatorFilter = filter.filter((item) => {
      return item.indexOf('litigator') > -1;
    });

    const matchTypeFilter = filter.filter((item) => {
      return item.indexOf('match') > -1;
    });

    const filterObj = {
      security: securityFilter,
      license: licenseFilter,
      litigator: litigatorFilter,
      matchType: matchTypeFilter,
      customChecksum,
    };

    return (
      <div>
        {filterObj.customChecksum && (
          <Label.Group>
            <span>
              <strong>{t('settings.list.sha256')}</strong>
            </span>
            <Label>
              {customChecksum}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearCustomApply();
                }}
              />
            </Label>
          </Label.Group>
        )}
        {filterObj.security.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.menu.security_risk_severity')}</strong>
            </span>
            {filterObj.security.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_c') > -1 && t('contents_header.menu.critical')}
                  {item.indexOf('_h') > -1 && t('contents_header.menu.high')}
                  {item.indexOf('_m') > -1 && t('contents_header.menu.medium')}
                  {item.indexOf('_l') > -1 && t('contents_header.menu.low')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.matchType.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.menu.match_type')}</strong>
            </span>
            {filterObj.matchType.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_i') > -1 && t('contents_header.menu.identifier_matching')}
                  {item.indexOf('_h') > -1 && t('contents_header.menu.hash_matching')}
                  {item.indexOf('_f') > -1 && t('contents_header.menu.fuzzy_matching')}
                  {item.indexOf('_m') > -1 && t('contents_header.menu.manifest_matching')}
                  {item.indexOf('_u') > -1 && t('contents_header.menu.user_defined')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.license.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.license')}</strong>
            </span>
            {filterObj.license.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_pt') > -1 && 'Protective'}
                  {item.indexOf('_pm') > -1 && 'Permissive'}
                  {item.indexOf('_o') > -1 && 'Others'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.litigator.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.litigator')}</strong>
            </span>
            {filterObj.litigator.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_mc') > -1 && 'McHardy'}
                  {item.indexOf('_sf') > -1 && 'SFC'}
                  {item.indexOf('_pt') > -1 && 'Patent Module'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filter.length !== 0 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  };

  renderString = (string) => {
    if (!string) {
      return null;
    }
    const data = string.split(',');
    return (
      <table className="table_type_2">
        <tbody>
          {
            data.map((item) => {
              return (
                <tr key={uuidv4()}>
                  <td style={{ height: '5px', padding: '6px 0 0 5px', lineHeight: '12px' }}>
                    {item}
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    );
  };

  renderCheckEvent = () => {
    let drag = false;
    let operation;
    document.addEventListener('mousedown', () => {
      drag = false;
      return drag;
    });

    document.addEventListener('mousemove', () => {
      drag = true;
      return drag;
    });

    document.addEventListener('mouseup', () => {
      if (drag) {
        operation = 'drag';
      } else {
        operation = 'click';
      }
      this.operation = operation;
    });
  };

  render() {
    const {
      error,
      hasMore,
      isLoading,
      isDetailLoading,
      isVisible,
      scannedFileList,
      activeIndex,
      sortValue,
      isSort,
      filter,
      currentCount,
      matchedList,
      popupIndex,
      popupType,
      customChecksum,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      isRenderListOnly,
      isOpenMIF,
      isOpenMER,
      isOpenMDP,
      isOpenWarnModal,
      isLoaderMER,
      componentList,
      sumData,
      hasLanguage,
      selectedScannedFileName,
      idReport,
      selectedScannedFileId,
      selectedComponentList,
      searchKeyword,
      isOpenMFD,
      currentScannedFileId,
      currentScannedFileName,
      commentList
    } = this.state;

    const {
      location, state, params, t, navigate,
    } = this.props;

    return (
      <div
        className="result_file"
        ref={this.overviewDetail}
      >
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          count={currentCount}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          handlePrecisionLevel={this.setPrecisionLevel}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          location={location}
          state={state}
          params={params}
          translate={t}
          navigate={navigate}
          searchKeyword={searchKeyword}
          handleSearchChange={this.handleSearchChange}
        />
        <div className="content">
          {filter.length !== 0 || customChecksum ? <div className="tag_list">{this.renderValue()}</div> : null}
          <div className="content_projects_List">
            <div className="wide_card_wrap">
              <div className="table_header">
                <div className="table_header_inner">
                  <table className="wide_card_table wide_card_scope">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '10%', maxWidth: '100px' }} />
                      <col style={{ width: '7%', maxWidth: '84px' }} />
                      <col style={{ width: '6.8%' }} />
                      <col style={{ width: '8%' }} />
                      <col style={{ width: '8%' }} />
                      <col style={{ width: '9%' }} />
                      <col style={{ width: '43%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="checkbox_wrap tal">
                          <div className="checkbox" />
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="1" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.scanned_file')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tar">
                          <a className="sorting_button" data-id="2" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.matched_comp')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="3" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('contents_header.menu.match_type')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="10" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.confidence_score')}
                            {isSort && sortValue === '10' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '10' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="4" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.component')}
                            {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="5" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.component_version_ellipsis')}
                            {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="sum_th">
                          <table>
                            <colgroup>
                              <col style={{ width: '41.1%' }} />
                              <col style={{ width: '34%' }} />
                              <col style={{ width: '13%' }} />
                              <col style={{ width: '12%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="6"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.security_risk')}
                                    {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="7"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.license')}
                                    {isSort && sortValue === '7' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '7' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="8"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.title_license')}
                                    {isSort && sortValue === '8' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '8' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="9"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.litigator')}
                                    {isSort && sortValue === '9' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '9' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {scannedFileList.map((item, index) => {
                return (
                  <div
                    className={cx(
                      'wide_card_box wide_card_type_01',
                      {
                        expand: activeIndex.indexOf(index) >= 0,
                      },
                      {
                        card_detail_popup_show: popupIndex.indexOf(index) >= 0,
                      },
                      {
                        type_0: popupType === 'type_0',
                      },
                    )}
                    key={`${item.scannedFileId}_${item.name}`}
                  >
                    <table
                      className="wide_card_table wide_card_item"
                    >
                      <colgroup>
                        <col style={{ width: '3.9%', maxWidth: '36px' }} />
                        <col style={{ width: '10%', maxWidth: '100px' }} />
                        <col style={{ width: '7%', maxWidth: '84px' }} />
                        <col style={{ width: '63.8%' }} />
                        <col style={{ width: '4.3%', maxWidth: '40px' }} />
                      </colgroup>
                      <tbody>
                        <tr
                          className="first_line"
                          onClick={() => {
                            return this.toggleRow(index, item.scannedFileId, item.componentIds);
                          }}
                        >
                          <td className="checkbox_wrap border-none tal">
                            <div className="checkbox" />
                          </td>
                          <td
                            className="border-none tal"
                            style={{
                              maxWidth: '120px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {
                              item.matchType === 'custom_apply' ? (
                                <strong>
                                  <Icon name="check circle outline" />
                                  {item.isBundled ? (<img style={{ marginRight: '3px', width: '14px', verticalAlign: 'bottom' }} src={jsBundled} alt="" />) : null}
                                  {item.name}
                                </strong>
                              ) : (
                                <strong>
                                  {item.isBundled ? (<img style={{ marginRight: '3px', width: '14px', verticalAlign: 'bottom' }} src={jsBundled} alt="" />) : null}
                                  {item.name}
                                </strong>
                              )
                            }
                          </td>
                          <td className="tar border-none tar">{item.componentCount}</td>
                          <td className="sum_td" colSpan="5">
                            <table className="wide_card_table wide_card_item">
                              <colgroup>
                                <col style={{ width: '10.5%' }} />
                                <col style={{ width: '10.5%' }} />
                                <col style={{ width: '10.5%' }} />
                                <col style={{ width: '10.5%' }} />
                                <col style={{ width: 'auto' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td
                                    className="tac"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {item.componentMatchType}
                                  </td>
                                  <td
                                    className="tac"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {item.componentScore}
                                  </td>
                                  <td
                                    className="tac"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {item.componentName}
                                  </td>
                                  <td
                                    className="tac"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {item.componentVersion}
                                  </td>
                                  <td className="sum_td">
                                    <table className="sub_table">
                                      <colgroup>
                                        <col style={{ width: '41.1%' }} />
                                        <col style={{ width: '34%' }} />
                                        <col style={{ width: '13%' }} />
                                        <col style={{ width: 'auto' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td className="tac">
                                            <div className="belt_chart">
                                              <div className="red">
                                                {item.securityCount.critical}
                                              </div>
                                              <div className="orange">
                                                {item.securityCount.high}
                                              </div>
                                              <div className="cheese">
                                                {item.securityCount.medium}
                                              </div>
                                              <div className="yellow">
                                                {item.securityCount.low}
                                              </div>
                                            </div>
                                            {
                                              item.hasExploit ? (<Icon name="bug" />) : null
                                            }
                                          </td>
                                          <td className="tac">
                                            <div className="belt_chart round">
                                              <div className="red">
                                                {item.licenseCount.protective}
                                              </div>
                                              <div className="cheese">
                                                {item.licenseCount.permissive}
                                              </div>
                                              <div className="yellow">
                                                {item.licenseCount.others}
                                              </div>
                                            </div>
                                          </td>
                                          <td
                                            className="tac"
                                            style={{
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            {item.titleLicense}
                                          </td>
                                          <td
                                            className="tac"
                                            style={{
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            {item.litigatorString}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="border-none tac">
                            <a
                              className="expand_button"
                            >
                              <img src={expandBtn} alt="" />
                            </a>
                          </td>
                        </tr>
                        {
                          isDetailLoading && isVisible === item.scannedFileId ? (
                            <tr>
                              <td className="border-none" colSpan="8">
                                <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                  <Loader active={isDetailLoading && isVisible === item.scannedFileId} inline="centered" />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr className="extend_item">
                              <td className="border-none">&nbsp;</td>
                              <td className="border-none tal">&nbsp;</td>
                              <td className="border-none tal">&nbsp;</td>
                              <td className="border-none sum_td" colSpan="5">
                                {
                                  item.componentList
                                  && (
                                    <ScannedFileRow
                                      childRef={this.viewRef}
                                      parentRowData={item.componentList}
                                      uid={item.uploadedFileId}
                                      sfid={item.scannedFileId}
                                      t={t}
                                    />
                                  )
                                }
                              </td>
                              <td className="border-none tal">&nbsp;</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                    {item.componentList ? (
                      <div>
                        {
                          item.componentList.match_type === 'custom_apply'
                          && (
                            <div className="wide_card_detail">
                              <div className="wide_card_detail_top">
                                <p className="title">{t('list.title.file_matched_ratio')}</p>
                                <PieChart key={`${item.componentList.scanned_file_id}_${item.componentList.name}`} chartData={item.componentList} translate={t} />
                                <p
                                  style={{ fontSize: '13px', margin: '8px 0 0 0', height: '16px' }}
                                  className="title"
                                >
                                  {t('list.title.user_defined_statistics')}
                                </p>
                                <dl className="big" style={{ marginTop: '44px' }}>
                                  <dt>
                                    <Label circular className="matched" />
                                    {t('list.title.matched_ratio')}
                                  </dt>
                                  <dd>{item.componentList.matched_ratio}</dd>
                                </dl>
                              </div>
                              <div className="wide_card_detail_bottom">
                                <div className="bottom_button_wrap">
                                  <a
                                    className={cx('card_detail_popup_show', {
                                      active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                                    })}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                  >
                                    {t('list.title.more_information')}
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  {
                                    item.componentList.has_manage_permission ? (
                                      <a
                                        className="left_button"
                                        onClick={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        onKeyUp={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    ) : (
                                      <a
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    )
                                  }
                                  <a
                                    className="right_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                  >
                                    <Icon name="comments outline" />
                                    <span>{t('modal.title.comment_show')}</span>
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  <a
                                    className="left_button"
                                    style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                  >
                                    {t('list.title.matched_detail')}
                                  </a>
                                  {
                                    item.componentList.is_dependency ? (
                                      <a
                                        className="right_button"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                        onKeyUp={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    ) : (
                                      <a
                                        className="right_button"
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                          )
                        }
                        {
                          item.componentList.match_type === 'fuzzy_match'
                          && (
                            <div className="wide_card_detail">
                              <div className="wide_card_detail_top">
                                <p className="title">{t('list.title.file_matched_ratio')}</p>
                                <PieChart key={`${item.componentList.scanned_file_id}_${item.componentList.name}`} chartData={item.componentList} translate={t} />
                                <p
                                  style={{ fontSize: '13px', margin: '8px 0 0 0', height: '16px' }}
                                  className="title"
                                >
                                  {t('contents_header.menu.fuzzy_match_stat')}
                                </p>
                                <dl className="big" style={{ marginTop: '44px' }}>
                                  <dt>
                                    <Label circular className="matched" />
                                    {t('list.title.matched_ratio')}
                                  </dt>
                                  <dd>{item.componentList.matched_ratio}</dd>
                                </dl>
                              </div>
                              <div className="wide_card_detail_bottom">
                                <div className="bottom_button_wrap">
                                  <a
                                    className={cx('card_detail_popup_show', {
                                      active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                                    })}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                  >
                                    {t('list.title.more_information')}
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  {
                                    item.componentList.has_manage_permission ? (
                                      <a
                                        className="left_button"
                                        onClick={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        onKeyUp={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    ) : (
                                      <a
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    )
                                  }
                                  <a
                                    className="right_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                  >
                                    <Icon name="comments outline" />
                                    <span>{t('modal.title.comment_show')}</span>
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  <a
                                    className="left_button"
                                    onClick={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    onKeyUp={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {t('list.title.matched_detail')}
                                  </a>
                                  {
                                    item.componentList.is_dependency ? (
                                      <a
                                        className="right_button"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                        onKeyUp={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    ) : (
                                      <a
                                        className="right_button"
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                          )
                        }
                        {
                          item.componentList.match_type === 'hash_match'
                          && (
                            <div className="wide_card_detail">
                              <div className="wide_card_detail_top">
                                <p className="title">{t('list.title.file_matched_ratio')}</p>
                                <PieChart key={`${item.componentList.scanned_file_id}_${item.componentList.name}`} chartData={item.componentList} translate={t} />
                                <p
                                  style={{ fontSize: '13px', margin: '8px 0 0 0', height: '16px' }}
                                  className="title"
                                >
                                  {t('contents_header.menu.hash_match_stat')}
                                </p>
                                <dl className="big" style={{ marginTop: '44px' }}>
                                  <dt>
                                    <Label circular className="matched" />
                                    {t('list.title.matched_ratio')}
                                  </dt>
                                  <dd>{item.componentList.matched_ratio}</dd>
                                </dl>
                              </div>
                              <div className="wide_card_detail_bottom">
                                <div className="bottom_button_wrap">
                                  <a
                                    className={cx('card_detail_popup_show', {
                                      active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                                    })}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                  >
                                    {t('list.title.more_information')}
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  {
                                    item.componentList.has_manage_permission ? (
                                      <a
                                        className="left_button"
                                        onClick={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        onKeyUp={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    ) : (
                                      <a
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    )
                                  }
                                  <a
                                    className="right_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                  >
                                    <Icon name="comments outline" />
                                    <span>{t('modal.title.comment_show')}</span>
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  <a
                                    className="left_button"
                                    onClick={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    onKeyUp={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {t('list.title.matched_detail')}
                                  </a>
                                  {
                                    item.componentList.is_dependency ? (
                                      <a
                                        className="right_button"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                        onKeyUp={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    ) : (
                                      <a
                                        className="right_button"
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                          )
                        }
                        {
                          item.componentList.match_type === 'identifier'
                          && (
                            <div className="wide_card_detail">
                              <div className="wide_card_detail_top">
                                <p className="title">{t('list.title.file_matched_ratio')}</p>
                                <MultiSeriesPieChart key={`${item.componentList.scanned_file_id}_${item.componentList.name}`} chartData={item.componentList} translate={t} />
                                <p
                                  style={{ fontSize: '13px', margin: '5px 0 0 0', height: '16px' }}
                                  className="title"
                                >
                                  {t('list.title.identifiers_match')}
                                </p>
                                <dl className="big">
                                  <dt>
                                    <Label circular className="unique" />
                                    {t('list.title.unique')}
                                  </dt>
                                  <dd>{item.componentList.unique_identifiers}</dd>
                                </dl>
                                <dl className="">
                                  <dt>
                                    {t('list.title.extracted')}
                                  </dt>
                                  <dd>{item.componentList.extracted_identifiers}</dd>
                                </dl>
                                <dl className="">
                                  <dt>
                                    <Label circular className="matched" />
                                    {t('list.title.matched')}
                                  </dt>
                                  <dd>{item.componentList.matched_identifiers}</dd>
                                </dl>
                                <dl className="">
                                  <dt>
                                    <Label circular className="unmatched" />
                                    {t('list.title.Unmatched')}
                                  </dt>
                                  <dd>{item.componentList.unmatched_identifiers}</dd>
                                </dl>
                                <dl className="">
                                  <dt>
                                    <Label circular className="ignored" />
                                    {t('list.title.ignored')}
                                  </dt>
                                  <dd>{item.componentList.ignored_identifiers}</dd>
                                </dl>
                              </div>
                              <div className="wide_card_detail_bottom">
                                <div className="bottom_button_wrap">
                                  <a
                                    className={cx('card_detail_popup_show', {
                                      active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                                    })}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                  >
                                    {t('list.title.more_information')}
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  {
                                    item.componentList.has_manage_permission ? (
                                      <a
                                        className="left_button"
                                        onClick={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        onKeyUp={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    ) : (
                                      <a
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    )
                                  }
                                  <a
                                    className="right_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                  >
                                    <Icon name="comments outline" />
                                    <span>{t('modal.title.comment_show')}</span>
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  <a
                                    className="left_button"
                                    onClick={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    onKeyUp={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {t('list.title.matched_detail')}
                                  </a>
                                  {
                                    item.componentList.is_dependency ? (
                                      <a
                                        className="right_button"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                        onKeyUp={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    ) : (
                                      <a
                                        className="right_button"
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                          )
                        }
                        {
                          item.componentList.match_type === 'manifest_match'
                          && (
                            <div className="wide_card_detail">
                              <div className="wide_card_detail_top">
                                <p className="title">{t('list.title.file_matched_ratio')}</p>
                                <PieChart key={`${item.componentList.scanned_file_id}_${item.componentList.name}`} chartData={item.componentList} translate={t} />
                                <p
                                  style={{ fontSize: '13px', margin: '8px 0 0 0', height: '16px' }}
                                  className="title"
                                >
                                  {t('list.title.manifest_match_stat')}
                                </p>
                                <dl className="big" style={{ marginTop: '44px' }}>
                                  <dt>
                                    <Label circular className="matched" />
                                    {t('list.title.matched_ratio')}
                                  </dt>
                                  <dd>{item.componentList.matched_ratio}</dd>
                                </dl>
                              </div>
                              <div className="wide_card_detail_bottom">
                                <div className="bottom_button_wrap">
                                  <a
                                    className={cx('card_detail_popup_show', {
                                      active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                                    })}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                  >
                                    {t('list.title.more_information')}
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  {
                                    item.componentList.has_manage_permission ? (
                                      <a
                                        className="left_button"
                                        onClick={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        onKeyUp={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    ) : (
                                      <a
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    )
                                  }
                                  <a
                                    className="right_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                  >
                                    <Icon name="comments outline" />
                                    <span>{t('modal.title.comment_show')}</span>
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  <a
                                    className="left_button"
                                    onClick={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    onKeyUp={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {t('list.title.matched_detail')}
                                  </a>
                                  {
                                    item.componentList.is_dependency ? (
                                      <a
                                        className="right_button"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                        onKeyUp={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    ) : (
                                      <a
                                        className="right_button"
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                          )
                        }
                        {
                          item.componentList.match_type === 'external_sbom'
                          && (
                            <div className="wide_card_detail">
                              <div className="wide_card_detail_top">
                                <p className="title">{t('list.title.file_matched_ratio')}</p>
                                <PieChart key={`${item.componentList.scanned_file_id}_${item.componentList.name}`} chartData={item.componentList} translate={t} />
                                <p
                                  style={{ fontSize: '13px', margin: '8px 0 0 0', height: '16px' }}
                                  className="title"
                                >
                                  {t('list.title.external_sbom_match')}
                                </p>
                                <dl className="big" style={{ marginTop: '44px' }}>
                                  <dt>
                                    <Label circular className="matched" />
                                    {t('list.title.matched_ratio')}
                                  </dt>
                                  <dd>{item.componentList.matched_ratio}</dd>
                                </dl>
                              </div>
                              <div className="wide_card_detail_bottom">
                                <div className="bottom_button_wrap">
                                  <a
                                    className={cx('card_detail_popup_show', {
                                      active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                                    })}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMoreInfo(index);
                                    }}
                                  >
                                    {t('list.title.more_information')}
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  {
                                    item.componentList.has_manage_permission ? (
                                      <a
                                        className="left_button"
                                        onClick={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        onKeyUp={() => {
                                          return this.getScannedFileEditDetails(item.uploadedFileId, item.scannedFileId, item.componentIds);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    ) : (
                                      <a
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        <Icon name="edit" />
                                        <span>{t('list.title.edit_scan_result')}</span>
                                      </a>
                                    )
                                  }
                                  <a
                                    className="right_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleMFDOpen(item.scannedFileId, item.name, item.componentList.more_information.comment);
                                    }}
                                  >
                                    <Icon name="comments outline" />
                                    <span>{t('modal.title.comment_show')}</span>
                                  </a>
                                </div>
                                <div className="bottom_button_wrap flex">
                                  <a
                                    className="left_button"
                                    onClick={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    onKeyUp={() => {
                                      return this.getMatchedList(item.uploadedFileId, item.scannedFileId);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {t('list.title.matched_detail')}
                                  </a>
                                  {
                                    item.componentList.is_dependency ? (
                                      <a
                                        className="right_button"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                        onKeyUp={() => {
                                          return this.handleMDPOpen(item.scannedFileId);
                                        }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    ) : (
                                      <a
                                        className="right_button"
                                        style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                      >
                                        {t('list.title.all_dependencies')}
                                      </a>
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    ) : null}
                    {item.componentList ? (
                      <div className="card_detail_popup card_detail_popup_1">
                        <div className="popup_box">
                          <h3 className="popup_header">
                            {t('list.title.more_information')}
                            <a
                              className="card_detail_popup_hide"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handlePopupClose(index);
                              }}
                              onKeyUp={() => {
                                return this.handlePopupClose(index);
                              }}
                            >
                              <img src={closeBtn} alt="" />
                            </a>
                          </h3>
                          <div className="popup_content">
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <div className="type_3">
                                <dl>
                                  <dt>{t('modal.leakage_info.scanned_file')}</dt>
                                  <dd className="text_ellipsis">{item.name}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('modal.leakage_info.parent_name')}</dt>
                                  <dd>{item.componentList.more_information.parent_name}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('modal.leakage_info.path')}</dt>
                                  <dd>{item.componentList.more_information.path}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('modal.leakage_info.size')}</dt>
                                  <dd>{item.componentList.more_information.size}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('modal.leakage_info.file_type')}</dt>
                                  <dd>{item.componentList.more_information.file_type}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('modal.leakage_info.language')}</dt>
                                  <dd>{item.componentList.more_information.language}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('modal.leakage_info.sha1')}</dt>
                                  <dd>{item.componentList.more_information.sha1}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('modal.leakage_info.sha256')}</dt>
                                  <dd>{item.componentList.more_information.sha_256}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('modal.leakage_info.tags')}</dt>
                                  <dd>{item.componentList.more_information.tags}</dd>
                                </dl>
                                {item.componentList.more_information.show_elf_analysis && (
                                  <div>
                                    <div className="line" />
                                    <dl>
                                      <dt>{t('modal.leakage_info.elf_analysis')}</dt>
                                      <dd className="pink">
                                        <em>{t('modal.leakage_info.decalared_shared_libraries')}</em>
                                      </dd>
                                    </dl>
                                    {
                                      this.renderString(item.componentList.more_information.elf_analysis.declared_shared_libraries)
                                    }
                                  </div>
                                )}
                              </div>
                            </Scrollbars>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                );
              })}
              {error && <div className="error_log">{error}</div>}
              {isLoading && (
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="medium" style={{ lineHeight: '15px' }}>Loading</Loader>
                  </Dimmer>
                </Segment>
              )}
              {
                viewMode === 'list' && scannedFileList.length !== 0
                && (
                  <div style={{ marginTop: '10px', textAlign: 'center' }} className="clar_pagination">
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      //size="mini"
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }
              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <MatchedModal
          isOpen={isOpenMIF}
          closeModal={this.handleClose}
          data={matchedList}
          translate={t}
          precisionLevel={state.user.currentPrecisionLevel}
        />
        <EditScanResultModal
          isOpenMER={isOpenMER}
          isLoaderMER={isLoaderMER}
          componentList={componentList}
          sumData={sumData}
          closeModal={this.handleMERClose}
          handleSaveCallback={this.handleSaveCallback}
          handleModalLoader={this.handleModalLoader}
          location={location}
          translate={t}
        />
        <DependencyModal
          isOpenMDP={isOpenMDP}
          hasLanguage={hasLanguage}
          closeModal={this.handleMDPClose}
          scannedFileName={selectedScannedFileName}
          uploadedFileId={idReport}
          scannedFileId={selectedScannedFileId}
          selectedComponentList={selectedComponentList}
          translate={t}
        />
        <FeedModal
          isOpenMFD={isOpenMFD}
          uploadedFileId={idReport}
          scannedFileId={currentScannedFileId}
          scannedFileName={currentScannedFileName}
          commentList={commentList}
          closeModal={this.closeMFDModal}
          translate={t}
        />
        <Modal open={isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap warn">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                {
                  this.smallBody ? (
                    <Modal.Description>
                      <Header>
                        {this.modalBody}
                      </Header>
                      <Modal.Content>{this.smallBody}</Modal.Content>
                    </Modal.Description>
                  ) : (
                    <Modal.Description className="center">
                      <Header>
                        {this.modalBody}
                      </Header>
                    </Modal.Description>
                  )
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(OverviewfileDetail))));
